import { render } from "./smtp-importer-settings.vue?vue&type=template&id=b08ea35c&ts=true"
import script from "./smtp-importer-settings.vue?vue&type=script&lang=ts"
export * from "./smtp-importer-settings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__